import React from "react";

const BuildStatus = () => {
    let { REACT_APP_RELASE_DATA = "-", REACT_APP_BUILD_DATA = "-", REACT_APP_DATE_TIME_DATA = "-" } = process.env;
    return <div data-app="buildStatus-component-wrapper" style={{ padding: 30 }}>
        <div><span style={{ fontWeight: "bold", paddingBottom: 30, minWidth: 105 }}>RELEASE: </span>{REACT_APP_RELASE_DATA} </div>
        <div><span style={{ fontWeight: "bold", paddingBottom: 30, minWidth: 105 }}>BUILD: </span>{REACT_APP_BUILD_DATA}</div>
        <div><span style={{ fontWeight: "bold", paddingBottom: 30, minWidth: 105 }}>DATE & TIME: </span>{REACT_APP_DATE_TIME_DATA}</div>
    </div>
}

export default BuildStatus;
